import { defineAsyncComponent } from 'vue'
export default {
  authorized: defineAsyncComponent(() => import("/buddy/pipeline-fs/layouts/authorized.vue")),
  buy: defineAsyncComponent(() => import("/buddy/pipeline-fs/layouts/buy.vue")),
  default: defineAsyncComponent(() => import("/buddy/pipeline-fs/layouts/default.vue")),
  guest: defineAsyncComponent(() => import("/buddy/pipeline-fs/layouts/guest.vue")),
  "guest-or-apply-promo-code": defineAsyncComponent(() => import("/buddy/pipeline-fs/layouts/guestOrApplyPromoCode.vue"))
}